import React, { useState } from 'react'
import './monitorCuidados.css'
import { MiFooter } from '../../components/footer/MiFooter';
import { ContentBodyMonitorCuidados } from '../../components/monitorCuidados/ContentBodyMonitorCuidados';
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import HeaderHome from '../../components/headerHome/HeaderHome';

export const MonitorCuidados = (props) => {
    const [MenuLateralAux, setMenuLateralAux] = useState();

    const chageMenuLateralAux = () => {
        setMenuLateralAux(!MenuLateralAux)
    }
    return (
        <div className='MonitorCuidados' >
            <div className='headerMonitorCuidados'>
                <HeaderHome
                    chageMenuLateralAux={chageMenuLateralAux}
                />
            </div>
            <div className="bodyMonitorCuidados">
                <ContentBodyMonitorCuidados
                    MenuLateralAux={MenuLateralAux}
                    chageMenuLateralAux={chageMenuLateralAux}
                />
            </div>
            <div className='footerReservarServicio'>
                <MiFooter />
            </div>
        </div>
    )
}
